'use client';

import type { Anniversary } from '@/lib/types';
import { AnniversaryCard } from './anniversary-card';
import { Card, CardContent } from './ui/card';

type AnniversaryListProps = {
  anniversaries: Anniversary[];
  title: string;
  emptyMessage: string;
};

export function AnniversaryList({
  anniversaries,
  title,
  emptyMessage,
}: AnniversaryListProps) {
  if (anniversaries.length === 0) {
    return (
      <Card>
        <CardContent className="pt-6">
          <p className="text-center text-muted-foreground">{emptyMessage}</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {anniversaries.map((anniversary) => (
          <AnniversaryCard key={anniversary.id} anniversary={anniversary} />
        ))}
      </div>
    </div>
  );
}
